export default __webpack_public_path__ + "static/media/discord-icon.13418f8d.svg";